import React from 'react';
import { observer } from 'mobx-react';
import { useFormikContext } from 'formik';

import useSession from 'core/hooks/use-session';
import { useStore } from 'core/store';
import { useDisabledState } from 'common/disabled-context';
import FormList from 'core/components/form-list';

import LossSummary from './loss-summary';
import LossHistoryItem from './loss-history-item';
import AddLossHistoryForm from './add-loss-history-form';

// #33939 — Loss History Detail for farm policies (types F/Z/Y). Segment-level list of loss
// entries (auto-pulled report data + manual entries) plus a real-time Loss Summary rollup.
// Everyone can VIEW the list/summary. On a POLICY, only an underwriter (canApproveUWReview) may
// add/edit/delete entries or toggle Ignore (#33957 review — changing loss history on a bound
// policy is a UW action; the backend policy-mod path enforces this too). The summary is always
// visible. (Editing on OFFERS is governed by offer-edit permission, not UW — a separate mount.)
const LossHistory = () => {
  const session = useSession();
  const { values } = useFormikContext();
  const { disabled } = useDisabledState();
  const {
    account: {
      policies: { policy: policyStore }
    }
  } = useStore();

  const policy = policyStore.policy;
  const uw = Boolean(session.canApproveUWReview);

  return (
    <>
      <LossSummary entries={values.lossHistory} referenceDate={policy?.effectiveDate} />
      <FormList
        id="lossHistory"
        title="Loss History Detail"
        singular="Loss"
        plural="Losses"
        item={LossHistoryItem}
        addForm={AddLossHistoryForm}
        addLabel="Add Loss History Entry"
        disabled={disabled || session.viewOnly || !uw}
        isUnderwriter={uw}
      />
    </>
  );
};

export default observer(LossHistory);
